export default __webpack_public_path__ + "static/media/entrance.08cbfba5.png";